import React from "react";
import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";

import App from "./App";
import "./index.css";
import { ScrollProvider } from "./contexts/ScrollContext";
import { AuthProvider } from "./contexts/AuthContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <HashRouter>
    <AuthProvider>
      <ScrollProvider>
        <App />
      </ScrollProvider>
    </AuthProvider>
  </HashRouter>
);
